import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useUpdateSettings } from './hooks'
import { hasAccessToThis } from 'services/Utilities'
import { MFilters } from 'types/filterTypes'
import { Button } from 'ui'

type ClearButtonProps = {
  contentName: MFilters.ContentTypes
  className?: string
  style?: React.CSSProperties
  type?: string
  filters?: string[]
  onClick?: () => void
}

const ClearButton: FC<ClearButtonProps> = ({ className, style, type, contentName, filters, onClick }) => {
  const filterKey: MFilters.FilterKey = `filter-${contentName}`
  const settings = useSelector((state: MStore.RootState) => state.settings)
  const savedOptions = useMemo(() => {
    return settings[filterKey] || {}
  }, [settings, filterKey])

  const limitToReportsTo = hasAccessToThis('limitToReportsTo')
  const { saveOptions } = useUpdateSettings(contentName)

  const clearSelection = () => {
    const newTypeOptions = { ...savedOptions }

    if (type) {
      newTypeOptions[type] = []
      saveOptions(newTypeOptions)
    }
    if (filters) {
      const advancedFiltersNewOptions = [...filters, 'others'].reduce((obj, key) => {
        obj[key] = []
        return obj
      }, {})

      const newFilters = { ...advancedFiltersNewOptions }

      if ('rangeStart' in savedOptions && 'rangeEnd' in savedOptions) {
        newFilters['rangeStart'] = savedOptions.rangeStart
        newFilters['rangeEnd'] = savedOptions.rangeEnd
      }
      if (limitToReportsTo && 'reportsTo' in savedOptions) {
        newFilters['reportsTo'] = savedOptions.reportsTo
      }
      saveOptions(newFilters)
    }
  }
  return (
    <Button color="secondary" outlined size="small" className={className ? className : 'mr-1'} style={style} onClick={onClick ? onClick : clearSelection}>
      <i className="fas fa-trash"></i>
    </Button>
  )
}

export default ClearButton
